export const socialsData = {
    github: "https://github.com/PriyankaBed",
    email: "mailto:priyanka.bed@outlook.com",
    linkedIn: "https://www.linkedin.com/in/priyankaben-bed-b122b1250/",
    xing: "https://www.xing.com/profile/Priyankaben_Bed/cv",
};
